import { Container } from 'react-bootstrap';
import "../../Styles/yellowcalf.css/Receipt_invoice.css";
import logo from '../../images/logo.svg';


export default function Receipt_invoice () {
  const executeDocumentPrint = () => {
    window.print();
  };

  return (
    <div className="billing-document-wrapper">
      <div className="billing-header-label">
        <h1>Invoice</h1>
      </div>

      <Container fluid className="p-0">
        <div className="primary-receipt-container">
          <div className="company-branding-section">
            <div className="logo-trademark-wrapper">
              <img
                src={logo}
                alt="Company Logo"
                className="brand-identity-image"
              />
            </div>

            <div className="contact-details-section">
              <p>stage.edsys.in</p>
              <p>info@trackschoolbus.com</p>
            </div>

            <div className="receipt-metadata-area">
              <h2>Invoice Receipt</h2>
              <p>Date 27-07-2020</p>
            </div>
          </div>

          <div className="institution-identifier-row">
            <p className="institution-label-text">School Name</p>
            <p className="institution-value-text">Demo school for development</p>
          </div>

          <table className="financial-breakdown-table">
            <thead>
              <tr>
                <th>Invoice Item</th>
                <th>Amount</th>
                <th>Quantity</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="line-item-description-cell">
                  Monthly Subscription<br />Charges for July 2020
                </td>
                <td>$ 2700</td>
                <td>1</td>
                <td>$ 2700</td>
              </tr>
              <tr className="subtotal-summary-row">
                <td colSpan="2"></td>
                <td>Grand Total</td>
                <td>$ 2700</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="action-controls-section">
          <button
            className="print-trigger-button"
            onClick={executeDocumentPrint}
          >
            Print
          </button>
        </div>
      </Container>
    </div>
  );
}
